var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.mixes)?_c('BaseSection',{attrs:{"padded":""}},[_c(_setup.MixGridBlock,{attrs:{"mixes":_setup.mixes}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }